import { PRODUCT_VIEW_LAYER } from '../../../components/AssetTargetsDialog/helpers/assetProductLinks';

/**
 * Whether the current gallery context owns the channel pending alt change.
 * Owner context shows the unpublished dot; non-owner contexts show "pending in …".
 */
export default function isPendingOwnedByCurrentContext({
  pendingOwner,
  viewContext,
  productId,
  linkVariantId,
  isVariant,
}) {
  if (!pendingOwner?.type || !pendingOwner?.id) return false;

  const layer = viewContext?.layer;
  if (layer === PRODUCT_VIEW_LAYER.MASTER || layer === PRODUCT_VIEW_LAYER.LIVE) {
    return false;
  }

  if (pendingOwner.type === 'listing') {
    const listingProductId = viewContext?.listingProductId || productId;
    return !isVariant && String(pendingOwner.id) === String(listingProductId);
  }

  if (pendingOwner.type === 'listingVariant') {
    return isVariant && String(pendingOwner.id) === String(linkVariantId);
  }

  return false;
}
